import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_UPLOAD_TEMPLATE_GROUPS_PAGE: IInventoryPage = {
	'route': '/upload/upload/template-groups',
	'title': 'Template Groups',
	'uiReference': [],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/upload-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/template-groups/template-groups.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/template-groups/template-groups.component.html'
	]
};
